const isBrowser = !!window;

export const getCurrentHost = () => {
  return isBrowser && window.location.host || '';
};

export const getCurrentDomain = () => {
  return getCurrentHost().split('.').splice(-2).join('.');
};
